import { Icon } from "@material-ui/core";
import { IAreaSelectionUtil } from "Interfaces/Utils/IAreaSelectionUtil";
import { resolve } from "inversify-react";
import { Area } from "Models/Areas/Area";
import * as React from "react";
import Types from "ServiceProvider/Types";
import styles from "./AreaNavigator.scss";

interface IProps {
    areas?: Area[];
    selectedArea?: Area;
    filter: string;
    areaSelectedEvent(selectedArea: Area): void;
}

class AreaNavigator extends React.Component<IProps> {
    @resolve(Types.IAreaSelectionUtil) public areaSelectionUtil: IAreaSelectionUtil;

    constructor(props: IProps) {
        super(props);

        this.onAreaSelectedEvent = this.onAreaSelectedEvent.bind(this);
        this.renderColumn = this.renderColumn.bind(this);
    }

    public onAreaSelectedEvent(event: React.MouseEvent<HTMLLIElement>, area: Area, column: number) {
        window.setTimeout(() => {
            const areaNavigator = document.getElementById("areaNavigator");
            if (areaNavigator) {
                areaNavigator.scrollLeft = areaNavigator.scrollWidth;
            }
        });

        if (this.props.areaSelectedEvent) {
            this.props.areaSelectedEvent(area);
        }
    }

    public render() {
        const selectedAreas = (this.props.selectedArea)
            ? this.areaSelectionUtil.getAreaRecursiveParents(this.props.selectedArea)
            : [];

        return (
            <div id="areaNavigator" className={styles.areaNavigator}>
                {this.props.areas && this.renderColumn(0, this.areaSelectionUtil.getFilteredAreaCollection(this.props.areas, this.props.filter))}
                {selectedAreas.map((area: Area, index: number) => {
                    const children = this.areaSelectionUtil.getFilteredAreaCollection(area.children!, this.props.filter);
                    return (children.length > 0)
                        ? this.renderColumn(index + 1, children)
                        : null;
                })}
            </div>
        );
    }

    public renderColumn(columnNumber: number, areas?: Area[]) {
        const selectedAreas = (this.props.selectedArea)
            ? this.areaSelectionUtil.getAreaRecursiveParents(this.props.selectedArea)
            : [];

        return (
            <div className={styles.column} key={columnNumber}>
                <ul className={styles.columnList}>
                    {
                        areas !== undefined && areas.map((area) => {
                            const selectedClassName = (selectedAreas.indexOf(area) >= 0) ? styles.selected_area : undefined;
                            return (
                                <li key={area.id} onClick={((e) => this.onAreaSelectedEvent(e, area, columnNumber))}
                                    className={selectedClassName}>
                                    {area.name}
                                    {this.areaSelectionUtil.getFilteredAreaCollection(area.children!, this.props.filter).length > 0
                                        && <Icon className={styles.hasChildren}>arrow_forward_ios</Icon>}
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        );
    }
}

export default AreaNavigator;


// WEBPACK FOOTER //
// ./src/Components/AreaSelection/AreaNavigator/AreaNavigator.tsx